<template>
  <b-card no-body @click="emitOptionsModal(item)">
    <b-row no-gutters>
      <b-col>
        <b-card-body v-if="!displayImages">
          <b-row>
            <b-col cols="10" sm="11">
              <b-row><b-col><b>{{ item.std_price  | toCurrency }} / {{ item.name }}</b></b-col></b-row>
              <b-row class="pt-1" style="font-size:80%; line-height:1.2;"><b-col>{{ item.description }}</b-col></b-row>
            </b-col>
            <b-col cols="1" class="itemcol">
              <b-button v-if="item.qtycnt" class="py-0" disabled pill variant="dark">{{ item.qtycnt }}</b-button>
              <b-button v-else size="lg" disabled pill variant="outline-dark"> &nbsp; </b-button>
            </b-col>
          </b-row>
        </b-card-body>
        <b-card-body v-else>
          <b-row>
            <b-col cols="3" sm="2" class="itemcol">
                <b-card-img v-bind="imgProps" class="px-lg-4 item-img" :src="item.image_path" :alt="item.name" ></b-card-img>
            </b-col>
            <b-col cols="7" sm="8">
              <b-row><b-col><b>{{ item.std_price  | toCurrency }} / {{ item.name }}</b></b-col></b-row>
              <b-row class="pt-1" style="font-size:80%; line-height:1.2;"><b-col>{{ item.description }}</b-col></b-row>
            </b-col>
            <b-col cols="1" class="itemcol">
              <b-button v-if="item.qtycnt" class="py-0" disabled pill variant="dark">{{ item.qtycnt }}</b-button>
              <b-button v-else size="lg" disabled pill variant="outline-dark"> &nbsp; </b-button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: 'Item',
  props: ['item', 'displayImages'],
  data () {
    return {
      imgProps: { blank: true, blankColor: '#FFF', width: 70, height: 70, class: 'm1' }
    }
  },
  methods: {
    emitOptionsModal(item) {
      this.$emit('optionsemit', item, false);
    }
  },
}
</script>

<style>

.item-price {
  padding-top: 1rem;
  float: left;
}

.item-add {
  float: right;
  margin-bottom: 1rem;
}

p.card-text {
  font-size: 0.8rem;
}

.item-img {
  border-radius: 50% !important;
}

.itemcol {
  margin: 0;
  margin-top: auto;
  margin-bottom: auto;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.customcard {
    max-width: 320px;
    margin: auto;
    /* width: 50%; */
    margin-top: 2px;
    margin-bottom: 2px;
    color: black;
}

@media (min-width: 768px) {
  .customcard {
      max-width: 540px;
      margin: auto;
      /* width: 50%; */
      margin-top: 2px;
      margin-bottom: 2px;
  }

  /* .item-img {
    margin-top: 1rem;
    margin-bottom: 1rem;
  } */
}

@media (min-width: 468px) {
  .item-img {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@media (min-width: 576px) {
  .item-img {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
}

</style>
